<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    <h2> Zawnioskuj o zmianę loginu</h2>
  </div>
  <div fxFlex="100"  >

    <app-dict-hiperio-config fxFlex="100" label="Dostęp" [control]="hiperioConfigControl"  [required]="true" ></app-dict-hiperio-config>

  </div>

  <div fxFlex="100" *ngIf="partnerId">

    <app-dict-registrations fxFlex="100" label="Rejestracja" [control]="registrationControl"  [required]="true" [filterInsuranceCompany]="insuranceCompany"  [filterPartnerId]="partnerId" [filterStatus]="[REGISTRATION_STATUS_REGISTERED]" ></app-dict-registrations>

  </div>
  <div fxFlex="100"  *ngIf="!partnerId">

    <app-dict-registrations fxFlex="100" label="Rejestracja" [control]="registrationControl"  [required]="true" [filterInsuranceCompany]="insuranceCompany"  [filterOfwca]="ofwca" [filterStatus]="[REGISTRATION_STATUS_REGISTERED]"  ></app-dict-registrations>

  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
